import { memo, useEffect, useState } from "react";

import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  Textarea,
} from "../ui";

export interface CommentDialogProps {
  isOpen: boolean;
  title: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
  isPending?: boolean;
  /**
   * Вызывается при подтверждении с введённым комментарием.
   */
  onConfirm: (comment: string) => void;
  /**
   * Вызывается при закрытии/отмене диалога.
   */
  onCancel: () => void;
}

export const CommentDialog = memo(function CommentDialog({
  isOpen,
  title,
  description,
  confirmText = "Подтвердить",
  cancelText = "Отмена",
  isPending = false,
  onConfirm,
  onCancel,
}: CommentDialogProps) {
  const [comment, setComment] = useState("");

  useEffect(() => {
    if (!isOpen) {
      setComment("");
    }
  }, [isOpen]);

  const handleConfirm = () => {
    onConfirm(comment);
  };

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onCancel();
        }
      }}
    >
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description && (
            <DialogDescription className="text-left">{description}</DialogDescription>
          )}
        </DialogHeader>

        <div className="space-y-4 mt-3">
          <Textarea
            placeholder="Введите комментарий..."
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            className="min-h-[100px]"
            maxLength={500}
          />
          {comment.length >= 500 && (
            <p className="text-xs text-red-500">
              Количество символов в поле не должно превышать 500.
            </p>
          )}
        </div>

        <DialogFooter className="mt-5 flex gap-3 justify-end">
          <Button variant="outline" onClick={onCancel}>
            {cancelText}
          </Button>
          <Button onClick={handleConfirm} disabled={!comment.trim() || isPending}>
            {confirmText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
});
